import { render, staticRenderFns } from "./read-solid.vue?vue&type=template&id=011b5ae4&"
import script from "./read-solid.vue?vue&type=script&lang=js&"
export * from "./read-solid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports